/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Count from './Count/index'
import DownpaymentAmount from './DownpaymentAmount/index'
import FirstInstallmentDate from './FirstInstallmentDate/index'
import InstallmentAmount from './InstallmentAmount/index'
import InstallmentInterval from './InstallmentInterval/index'
import MakePrimaryAction from './MakePrimaryAction/index'
import PaymentDay from './PaymentDay/index'
import PaymentPlanLength from './PaymentPlanLength/index'
import PayorShare from './PayorShare/index'
import Person from './Person/index'
import PrimaryPayorTag from './PrimaryPayorTag/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import Stat from './Stat/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payor({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/New/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor"
  
}) {
let payorItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'payor_item',
path: 'isFirst',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let payorValueData = fromData.useDataValue({ viewPath,
context: 'payor',
})
let paymentPlanValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let aggregateData = fromHelpers.getPayorShareAfterDiscountsFormatted(payorValueData, paymentPlanValueData)
let payorDownpaymentAmountValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'downpayment_amount',
format: fromFormat.numberMoney,
})
let payorInstallmentAmountValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'installment_amount',
format: fromFormat.numberMoney,
})
let payorValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
})
let paymentPlanValueData1 = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let aggregateData1 = fromHelpers.getLastInstallmentAmountFormatted(payorValueData1, paymentPlanValueData1)
let payorPaymentPlanLengthValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'payment_plan_length',
})
  return (<React.Fragment
>
<div
  data-testid="Payor.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-5xK8b': dtColorsNeutral200,'--mt-6-5xK8b': payorItemIsFirstValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Payor.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-7-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-10-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-11-5xK8b': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Count
  viewPath={`${viewPath}/Count`}
/>
<Person
  viewPath={`${viewPath}/Person`}
/>
<PrimaryPayorTag
  viewPath={`${viewPath}/PrimaryPayorTag`}
/>
<MakePrimaryAction
  viewPath={`${viewPath}/MakePrimaryAction`}
/>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
<div
  data-testid="Payor.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-7-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-8-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-9-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-10-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Payor.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-12-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Stat
  viewPath={`${viewPath}/Stat`}
 text="Amount to pay"
 data="payor"
 data="payment_plan"
 aggregate="helpers.js getPayorShareAfterDiscountsFormatted"
 value={aggregateData}
 color="green"
/>
<Stat
  viewPath={`${viewPath}/Stat`}
 text="Downpayment"
 data="payor.downpayment_amount"
 format="/Data/format.js numberMoney"
 value={payorDownpaymentAmountValueData}
 color="blue"
/>
<Stat
  viewPath={`${viewPath}/Stat`}
 text="Installment"
 data="payor.installment_amount"
 format="/Data/format.js numberMoney"
 value={payorInstallmentAmountValueData}
 color="magenta"
/>
<Stat
  viewPath={`${viewPath}/Stat`}
 text="Last payment"
 data="payor"
 data="payment_plan"
 aggregate="helpers.js getLastInstallmentAmountFormatted"
 value={aggregateData1}
 color="red"
/>
<Stat
  viewPath={`${viewPath}/Stat`}
 text="Months"
 data="payor.payment_plan_length"
 value={payorPaymentPlanLengthValueData}
 color="orange"
/>
</div>
<PayorShare
  viewPath={`${viewPath}/PayorShare`}
/>
<DownpaymentAmount
  viewPath={`${viewPath}/DownpaymentAmount`}
/>
<InstallmentAmount
  viewPath={`${viewPath}/InstallmentAmount`}
/>
<PaymentPlanLength
  viewPath={`${viewPath}/PaymentPlanLength`}
/>
<div
  data-testid="Payor.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-12-5xK8b': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-6-5xK8b': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<InstallmentInterval
  viewPath={`${viewPath}/InstallmentInterval`}
/>
<PaymentDay
  viewPath={`${viewPath}/PaymentDay`}
/>
<FirstInstallmentDate
  viewPath={`${viewPath}/FirstInstallmentDate`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}